export const WYArchivedApplicationsTeamsite = {
  heading: 'ARCHIVED APPLICATIONS',
  noResultsMessage: 'There are no archived applications to display.',
  sidebar: {
    headline: 'ARCHIVED APPLICATIONS',
    subText: 'Review information about customer application status.'
  },

  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH HIGHMARK'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
export const NDArchivedApplicationsTeamsite = {
  heading: 'ARCHIVED APPLICATIONS',
  noResultsMessage: 'There are no archived applications to display.',
  sidebar: {
    headline: 'ARCHIVED APPLICATIONS',
    subText:
      'Review information about customer application status from the Health Insurance Marketplace.'
  },

  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH BCBSND'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
